import React, { useCallback, useMemo } from "react";
import { RECORD_CONSTANTS } from "../../../constants";
import TaskAttributes from "./AttributeSections/TaskAttributes";
import CalendarAttributes from "./AttributeSections/CalendarAttributes";
import MapAttributes from "./AttributeSections/MapAttributes";
import styles from "./AttributeSections.module.css";

export default function AttributeSections({
  activeViews,
  attributes,
  onUpdate,
  onDeleteSection,
  register,
  mapInputRef,
  aiOverlay = {},
}) {
  const updateAttribute = useCallback((key, value) => {
    onUpdate(key, value);
  }, [onUpdate]);

  const taskAiOverlay = useMemo(
    () => ({
      isComplete: aiOverlay?.isComplete,
      dueDate: aiOverlay?.dueDate,
      priority: aiOverlay?.priority,
    }),
    [aiOverlay?.isComplete, aiOverlay?.dueDate, aiOverlay?.priority]
  );

  return (
    <div className={styles.container}>
      {activeViews.has(RECORD_CONSTANTS.VIEW_TYPES.TASK) && (
        <div ref={register(RECORD_CONSTANTS.VIEW_TYPES.TASK)} data-scrollable-section>
          <TaskAttributes
            isComplete={attributes.isComplete}
            dueDate={attributes.dueDate}
            priority={attributes.priority}
            onUpdate={updateAttribute}
            onDelete={() => onDeleteSection(RECORD_CONSTANTS.VIEW_TYPES.TASK)}
            aiOverlay={taskAiOverlay}
          />
        </div>
      )}

      {activeViews.has(RECORD_CONSTANTS.VIEW_TYPES.CALENDAR) && (
        <div ref={register(RECORD_CONSTANTS.VIEW_TYPES.CALENDAR)} data-scrollable-section>
          <CalendarAttributes
            dateRange={attributes.date}
            onUpdate={updateAttribute}
            onDelete={() => onDeleteSection(RECORD_CONSTANTS.VIEW_TYPES.CALENDAR)}
            aiOverlay={aiOverlay.date}
          />
        </div>
      )}

      {activeViews.has(RECORD_CONSTANTS.VIEW_TYPES.MAP) && (
        <div ref={register(RECORD_CONSTANTS.VIEW_TYPES.MAP)} data-scrollable-section>
          <MapAttributes
            location={attributes.location}
            onUpdate={updateAttribute}
            onDelete={() => onDeleteSection(RECORD_CONSTANTS.VIEW_TYPES.MAP)}
            inputRef={mapInputRef}
            aiOverlay={aiOverlay.location}
          />
        </div>
      )}
    </div>
  );
}
